module.exports = __webpack_public_path__ + "img/lilian.5248edd4.png";